import { FC } from 'react';
import Box, { BoxProps } from '@mui/material/Box';

export const CenterBox: FC<BoxProps> = ({ children, sx, ...rest }) => (
  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', ...sx }} {...rest}>
    {children}
  </Box>
);
